import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getGeoInfo } from "../../services/ipLocation";

import { fetchZones } from "../../services/zones";
import { updateMapCenter } from "./shippers";

const initialState = {
  data: null,
  status: "idle",
  geolocation: null,
};

export const getZones = createAsyncThunk("zones/fetch", async () => {
  const response: any = await fetchZones();

  return response;
});
export const getGeolocation = createAsyncThunk(
  "geolocation/fetch",
  async (params, { dispatch }) => {
    const response: any = await getGeoInfo();

    const { latitude: lat, longitude: lng } = response;

    dispatch(updateMapCenter({ center: { lat, lng }, zoom: 14 }));

    return response;
  }
);

export const zonesSlice = createSlice({
  name: "zones",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getZones.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getZones.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      })
      .addCase(getGeolocation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getGeolocation.fulfilled, (state, action) => {
        state.status = "idle";
        state.geolocation = action.payload;
      });
  },
});

export default zonesSlice.reducer;
